module.exports = __webpack_public_path__ + "img/CM-NL-24-Volkswagen-Playful.843df7e2.jpg";